export default "<li class=\"dropdown-menu-item\">\n  <i *ngIf=\"icon\" class=\"icon-{{icon}}\"></i>\n  <span class=\"light\" translate>{{text}}</span>\n</li>\n"